// extracted by mini-css-extract-plugin
export default {"header":"Header_header__-4UTA","underline":"Header_underline__JC3gw","light":"Header_light__iLB3e","dark":"Header_dark__u3pKE"};